import React from 'react';
import TrendIndicator from './TrendIndicator';

interface MetricRowProps {
  label: string;
  value: number;
  inverse?: boolean;
  subValue?: string;
}

// Metric Row Component
const MetricRow: React.FC<MetricRowProps> = ({ label, value, inverse = false, subValue }) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '4px 0',
      borderBottom: '1px solid rgba(0,0,0,0.1)'
    }}>
      <span style={{ fontWeight: 'bold' }}>{label}</span>
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <TrendIndicator value={value} inverse={inverse} />
        </div>
        {subValue && (
          <div style={{ 
            fontSize: '12px', 
            color: '#9e9e9e',
            textAlign: 'right',
            fontWeight: 'bold',
            marginTop: '2px'
          }}>
            {subValue}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricRow;
